import React from 'react';
import { Button } from './ui/button';
import { Phone, MessageCircle } from 'lucide-react';
import { companyInfo } from '../mock';

const Hero = () => {
  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phone}`;
  };

  const handleWhatsApp = () => {
    // Format: 491522757500 (country code 49 + number without leading 0)
    const phoneNumber = '491522757500';
    const message = encodeURIComponent('Hallo, ich interessiere mich für Ihre Hausmeister-Dienstleistungen.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1"
          alt="Professional maintenance service"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900/95 via-slate-800/90 to-slate-900/95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-6xl mx-auto text-center">
          {/* Logo as Main Headline - Top Center */}
          <div className="mb-4">
            <img 
              src="/stark-logo-full.png" 
              alt="STARK Hausmeisterservice & Dienstleistungen" 
              className="mx-auto max-w-full h-auto"
              style={{ maxHeight: '400px', width: 'auto' }}
            />
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 leading-tight px-4">
            {companyInfo.heroTitle}
          </h1>

          {/* Subtitle */}
          <div className="text-xl sm:text-2xl md:text-3xl font-semibold text-white mb-4 px-4">
            {companyInfo.heroSubtitle}
          </div>

          {/* Description */}
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-12 max-w-2xl mx-auto px-4">
            {companyInfo.heroDescription}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              onClick={handleCall}
              size="lg"
              className="w-full sm:w-auto bg-slate-900 hover:bg-slate-800 text-white text-lg px-8 py-6 shadow-2xl hover:shadow-slate-900/50 transition-all duration-300"
            >
              <Phone className="w-5 h-5 mr-2" />
              Jetzt anrufen
            </Button>
            <Button
              onClick={handleWhatsApp}
              size="lg"
              variant="outline"
              className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white border-green-600 text-lg px-8 py-6 shadow-2xl hover:shadow-green-600/50 transition-all duration-300"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </Button>
            <Button
              onClick={scrollToContact}
              size="lg"
              variant="outline"
              className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white border-white/30 text-lg px-8 py-6 backdrop-blur-md transition-all duration-300"
            >
              Angebot anfordern
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6">
              <div className="text-3xl font-bold text-white mb-2">24/7</div>
              <div className="text-white/80">Notfallservice</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6">
              <div className="text-3xl font-bold text-white mb-2">&lt; 24h</div>
              <div className="text-white/80">Schnelle Rückmeldung</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6">
              <div className="text-3xl font-bold text-white mb-2">100%</div>
              <div className="text-white/80">Zuverlässig</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white/50 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
